'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'ice-cream';
var width = 448;
var height = 512;
var aliases = [127848];
var unicode = 'f810';
var svgPathData = ['M48 216l0 24 16 0 72.4 0 175.3 0 72.4 0 16 0 0-24c0-13.3-10.7-24-24-24l-16.2 0-25.4 0 1.5-25.4c.1-2.2 .2-4.4 .2-6.6c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 2.2 .1 4.4 .2 6.6l1.5 25.4-25.4 0L72 192c-13.3 0-24 10.7-24 24z', 'M224 0C140.9 0 72.6 63.3 64.8 144.4C28.4 148 0 178.7 0 216l0 48 0 24 24 0 40 0 72.4 0 175.3 0 72.4 0 40 0 24 0 0-24 0-48c0-37.3-28.4-68-64.8-71.6C375.4 63.3 307.1 0 224 0zM112 160c0-61.9 50.1-112 112-112s112 50.1 112 112c0 2.2-.1 4.4-.2 6.6L334.3 192l25.4 0 16.2 0c13.3 0 24 10.7 24 24l0 24-16 0-72.4 0-175.3 0L64 240l-16 0 0-24c0-13.3 10.7-24 24-24l16.2 0 25.4 0-1.5-25.4c-.1-2.2-.2-4.4-.2-6.6zM224 512L347.4 320l-246.9 0L224 512z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIceCream = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;